import React, { useState } from "react";
import { Button, Modal, message } from "antd";
import Role from "../accountAuthorization";
import axios from "axios";
import localhost from "../../constants/localhost";

export default ({ userIds, type, successCb }) => {
  const [visible, setVisible] = useState(false);
  const [roleIds, setRoleIds] = useState([]);

  return (
    <>
      {type === "batch" && (
        <Button
          onClick={() => {
            if (!userIds?.length) {
              message.warning("请先选择用户！");
              return;
            }
            setVisible(true);
          }}
        >
          批量关联角色
        </Button>
      )}
      {type !== "batch" && <a onClick={() => setVisible(true)}>关联角色</a>}
      <Modal
        width={1000}
        open={visible}
        onCancel={() => setVisible(false)}
        destroyOnHidden
        title="关联角色"
        onOk={() => {
          if (!roleIds?.length) {
            message.warning("请先选择角色！");
            return;
          }
          const url =
            type === "batch"
              ? `${localhost}/manage/user/batchLinkRole`
              : `${localhost}/manage/user/linkRole`;
          axios
            .post(url, {
              roleIdList: roleIds,
              userIdList: type === "batch" ? userIds : undefined,
              userId: type !== "batch" ? userIds : undefined,
            })
            .then((res) => {
              message.success("删除成功！");
              successCb();
            })
            .catch((error) => {
              message.error("网络异常，请重试！");
            });
        }}
      >
        <Role
          pageMode="connent"
          updateSelectedRowKeys={(keys) => {
            setRoleIds(keys);
          }}
        />
      </Modal>
    </>
  );
};
